import axios, { type AxiosRequestConfig } from 'axios';
import { envApiUrl } from './envApiUrl';

// Utility function to make authenticated requests with CSRF tokens
export const axiosWithCSRF = async (config: AxiosRequestConfig) => {
  try {
    // First, get the CSRF token
    const csrfResponse = await axios.get(envApiUrl + '/auth/csrf-token', {
      withCredentials: true,
    });
    const csrfToken = csrfResponse.data.csrfToken;

    // Add CSRF token to headers
    const headers = {
      'Content-Type': 'application/json',
      'x-csrf-token': csrfToken,
      ...config.headers,
    };

    // Make the request with CSRF token
    return await axios({
      ...config,
      headers,
      withCredentials: true,
    });
  } catch (error) {
    console.error('CSRF token fetch failed:', error);
    throw error;
  }
};

// Convenience methods for common HTTP methods
export const getWithCSRF = (url: string, config?: AxiosRequestConfig) =>
  axiosWithCSRF({ ...config, method: 'GET', url });

export const postWithCSRF = (url: string, data?: any, config?: AxiosRequestConfig) =>
  axiosWithCSRF({ ...config, method: 'POST', url, data });

export const putWithCSRF = (url: string, data?: any, config?: AxiosRequestConfig) =>
  axiosWithCSRF({ ...config, method: 'PUT', url, data });

export const deleteWithCSRF = (url: string, config?: AxiosRequestConfig) =>
  axiosWithCSRF({ ...config, method: 'DELETE', url });

export const patchWithCSRF = (url: string, data?: any, config?: AxiosRequestConfig) =>
  axiosWithCSRF({ ...config, method: 'PATCH', url, data });
